import { render, staticRenderFns } from "./ProductCarousel.vue?vue&type=template&id=70c49758&scoped=true&"
import script from "./ProductCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProductCarousel.vue?vue&type=style&index=0&id=70c49758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c49758",
  null
  
)

export default component.exports